export default function ClinicsService() {
  const buttons = document.querySelectorAll('[data-scroll]');
  const container = document.querySelector('.right-side');

  if (buttons) {
    buttons.forEach((btn) => {
      btn.addEventListener('click', function onClick() {
        const parentSection = this.closest('.clinics-service');
        const block = parentSection.querySelector(`#${this.dataset.scroll}`);
        if (!block) {
          return;
        }
        if (container) {
          container.scrollTo({
            top: block.offsetTop,
            left: 0,
            behavior: 'smooth',
          });
        }
      });
    });
  }
}